import React from "react"
import TextCell, { TextCellProps } from "./TextCell"
import { ContentfulBicycleModel } from "../../../../graphql-types"

type WeightCellProps = TextCellProps & {
  bike: ContentfulBicycleModel
}

export default function WeightCell({
  bike,
  value: _value,
  ...props
}: WeightCellProps) {
  const maxWeight = bike.bodyFitMaxWeight
  return (
    <TextCell {...props} value={maxWeight ? `Up to ${maxWeight}lbs` : "N/A"} />
  )
}
